import { useEffect, type ReactNode } from 'react';

import { captureTrackingParamsFromUrl } from '../utils/adsConversionTrackingUtils';

/**
 * Captures fbclid/ttclid from the URL on first client mount and persists in localStorage,
 * so tracking params survive navigation and are available at signup and on signup success.
 */
export default function TrackingParamsProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    captureTrackingParamsFromUrl();
  }, []);

  return <>{children}</>;
}
